export default {"src":"/_next/static/media/icon-google.c360f576.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};